/**
 * インライン SVG アイコン (依存追加なし)。サイドバー/トップバー等で使用。
 * すべて currentColor の線アイコン。24x24。
 */
import type { ReactNode } from "react";

export interface IconProps {
  className?: string | undefined;
}

function Svg({
  children,
  className,
}: { children: ReactNode; className?: string | undefined }): JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className ?? "h-5 w-5"}
      aria-hidden="true"
    >
      {children}
    </svg>
  );
}

export const TodayIcon = ({ className }: IconProps): JSX.Element => (
  <Svg className={className}>
    <rect x="3" y="4" width="18" height="17" rx="2" />
    <path d="M3 9h18M8 2v4M16 2v4M9 14l2 2 4-4" />
  </Svg>
);

export const TasksIcon = ({ className }: IconProps): JSX.Element => (
  <Svg className={className}>
    <path d="M9 11l2 2 4-4" />
    <rect x="3" y="4" width="18" height="16" rx="2" />
  </Svg>
);

export const CasesIcon = ({ className }: IconProps): JSX.Element => (
  <Svg className={className}>
    <path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
  </Svg>
);

export const CustomersIcon = ({ className }: IconProps): JSX.Element => (
  <Svg className={className}>
    <circle cx="9" cy="8" r="3" />
    <path d="M3 20a6 6 0 0 1 12 0M16 11a3 3 0 1 0-1-5.8M21 20a6 6 0 0 0-4-5.6" />
  </Svg>
);

export const PipelineIcon = ({ className }: IconProps): JSX.Element => (
  <Svg className={className}>
    <rect x="3" y="4" width="5" height="16" rx="1" />
    <rect x="10" y="4" width="5" height="11" rx="1" />
    <rect x="17" y="4" width="4" height="7" rx="1" />
  </Svg>
);

export const MessagesIcon = ({ className }: IconProps): JSX.Element => (
  <Svg className={className}>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="M3 7l9 6 9-6" />
  </Svg>
);

export const AuditIcon = ({ className }: IconProps): JSX.Element => (
  <Svg className={className}>
    <rect x="5" y="3" width="14" height="18" rx="2" />
    <path d="M9 3.5h6a1 1 0 0 1 1 1V6a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V4.5a1 1 0 0 1 1-1zM9 12h6M9 16h4" />
  </Svg>
);

export const SettingsIcon = ({ className }: IconProps): JSX.Element => (
  <Svg className={className}>
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 13a1.7 1.7 0 0 0 .3 1.9l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-2.9 1.2v.2a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-2.9-1.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0-1.2-2.9H.4a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.3-2.9l-.1-.1A2 2 0 1 1 4.5 3l.1.1a1.7 1.7 0 0 0 1.9.3H6.6a1.7 1.7 0 0 0 1-1.5V1.7a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 2.9 1.2l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.9v.1a1.7 1.7 0 0 0 1.5 1h.2a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z" />
  </Svg>
);

export const BuildingIcon = ({ className }: IconProps): JSX.Element => (
  <Svg className={className}>
    <rect x="4" y="3" width="12" height="18" rx="1" />
    <path d="M16 8h4v13M8 7h0M12 7h0M8 11h0M12 11h0M8 15h0M12 15h0M9 21v-3h2v3" />
  </Svg>
);

export const BellIcon = ({ className }: IconProps): JSX.Element => (
  <Svg className={className}>
    <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9M13.7 21a2 2 0 0 1-3.4 0" />
  </Svg>
);

export const SearchIcon = ({ className }: IconProps): JSX.Element => (
  <Svg className={className}>
    <circle cx="11" cy="11" r="7" />
    <path d="M21 21l-4.3-4.3" />
  </Svg>
);

export const ChevronDownIcon = ({ className }: IconProps): JSX.Element => (
  <Svg className={className}>
    <path d="M6 9l6 6 6-6" />
  </Svg>
);

export const MenuIcon = ({ className }: IconProps): JSX.Element => (
  <Svg className={className}>
    <path d="M4 6h16M4 12h16M4 18h16" />
  </Svg>
);

export const LogoutIcon = ({ className }: IconProps): JSX.Element => (
  <Svg className={className}>
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9" />
  </Svg>
);
